import { extendsModule, baseFormItem } from 'src/store/base';
import * as types from 'src/store/types';

export default extendsModule(baseFormItem, {
  state: {
    _moduleKey: 'playable-creation-form-item',
    playableSwitch: [], // 是否打开了试玩开关
    playableUrl: [], // 选中的试玩链接
  },
  getters: {
    // 当表单项可见时，贡献的提交参数
    formItemData4Show(state) {
      return {
        playable_url: state.playableUrl,
        // playable 根据新版交互，不再用开关控制
        // playable_url: state.playableUrl.map((url, index) => {
        //   const isCurrentCardUsePlayable = state.playableSwitch[index];
        //   return isCurrentCardUsePlayable
        //     ? url
        //     : '';
        // }),
      };
    },
    // 当表单项隐藏时，贡献的提交参数
    formItemData4Hide() {
      return {
        playable_url: [],
      };
    },
    isSplitTestPlayableSame(state, getters) {
      const [url1, url2] = getters.formItemData4Show.playable_url;
      return url1 === url2;
    },
  },
  mutations: {
    [types.CHANGE_PLAYABLE_SWITCH](state, { splitTestTab = 0, value = false }) {
      const originPlayableSwitch = state.playableSwitch || [];
      originPlayableSwitch[splitTestTab] = !!value;
      const newPlayableSwitch = originPlayableSwitch.map(item => item);
      state.playableSwitch = newPlayableSwitch;
    },
    [types.UPDATE_PLAYABLE_URL](state, { splitTestTab = 0, value = '' }) {
      state.playableUrl.splice(splitTestTab, 1, value);
    },
  },
  actions: {
    data2State({ commit }, formData) {
      const base = {
        playableUrl: formData.playable_url || [],
      };
      // 在编辑、复制、use exist新建时，如果后端返回了试玩链接，则需要打开开关。
      // 使用setPcdAdByCreativeDetail方法时，会设置resetAutoName，其余情况默认false
      if (formData.resetSwitch) {
        base.playableSwitch = formData.playable_url.map(url => !!url);
      }
      commit('update', base);
    },
  },
});
